import Component from '../abstracts/Component';
import Bouncer from 'formbouncerjs';

export default class LoginValidationComponent extends Component {

  get SELECTORS() {
    return {
      container: '.login-form',
      validators: '[data-bouncer-message-missing-value]',
      submit: '.submit-input .button-primary'
    };
  }

  constructor() {
    super();

    this.loginValidator = null;
    this.container = $(this.SELECTORS.container);
  }

  bindEvents(el) {

    let ctx = this,
      $element = $(el),
      submit = $element.find(this.SELECTORS.submit);

    // check form is not valid
    document.addEventListener('bouncerFormInvalid', function (event) {

      if ($element.is(event.target)) {
        submit.attr('disabled', true);
      }

    }, false);


    // check form validated
    document.addEventListener('bouncerFormValid', function (event) {

      if ($element.is(event.target)) {
        submit.removeAttr('disabled');
      }

    }, false);

    document.addEventListener('bouncerRemoveError', function (event) {

      if ($(event.target).closest(ctx.SELECTORS.container).length) {
        let areValid = ctx.loginValidator.validateAll(el);
        if (areValid.length == 0) {
          submit.removeAttr('disabled');
        }
      }

    }, false);

  }

  render() {
    if (this.container.length) {
      this.log('rendering...');

      const validators = this.container.first().find(this.SELECTORS.validators);

      this.loginValidator = new Bouncer(this.SELECTORS.container, {
        disableSubmit: false,
        emitEvents: true,
        messages: {
          missingValue: {
            default: validators.attr('data-bouncer-message-missing-value')
          },
          patternMismatch: {
            default: validators.attr('data-bouncer-message'),
            email: validators.attr('data-bouncer-message-email')
          }
        },
      });

      this.container.each((index, element) => {
        this.bindEvents(element);
      });
    }
  }
}
